import { css } from '@/styled-system/css';

export const singleTextLineStyles = css.raw({
  display: 'block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export * from './emptyState';
export * from './wizard';
